import { render } from "./ObjectivesEmpty.vue?vue&type=template&id=220ebd44&scoped=true"
import script from "./ObjectivesEmpty.vue?vue&type=script&lang=js"
export * from "./ObjectivesEmpty.vue?vue&type=script&lang=js"

import "./ObjectivesEmpty.vue?vue&type=style&index=0&id=220ebd44&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-220ebd44"]])

export default __exports__